/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  DeleteRoutineMutationResponse,
  DeleteRoutinePathParams,
  DeleteRoutine401,
  DeleteRoutine403,
  DeleteRoutine404,
} from '../types/DeleteRoutine.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getDeleteRoutineUrl(id: DeleteRoutinePathParams['id']) {
  const res = { method: 'DELETE', url: `/routines/${id}` as const };
  return res;
}

/**
 * @summary Delete routine
 * {@link /routines/:id}
 */
export async function deleteRoutine(id: DeleteRoutinePathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteRoutineMutationResponse,
    ResponseErrorConfig<DeleteRoutine401 | DeleteRoutine403 | DeleteRoutine404>,
    unknown
  >({ method: 'DELETE', url: getDeleteRoutineUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
